import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { MachineFamillyService, DataService } from '../../shared/services';
import { map } from 'rxjs/operators';

@Injectable()
export class MachineSelectorFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, private machineService: MachineFamillyService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateMachine(inspectionId: string, pluginId: string, machine: any): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = machine;
            return { plugin };
          }
        })
      );
    }
    return this.getInspection(inspectionId).flatMap((inspection) => {
      return this.machineService.getModel(machine.ModelId).pipe(
        map((model) => {
          const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
          if (plugin) {
            if (inspection.data) {
              inspection.data.machine = machine;
            } else {
              inspection.data = {
                machine: machine
              };
            }
            inspection.data.machine.name = model ? model.name : machine.ModelName || machine.ModelId;
          }
          plugin.config = machine;
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return { data: inspection.data, plugin };
        })
      );
    });
  }
}
